import { inject, ref, watch } from "vue";
import { pathOr } from "ramda";
import {
  generateApiUrl,
  generateError,
  setUniqueArrayOfObjects,
  generateQueryStringWithKeysRepeat,
} from "@/shared/utils";
import httpService from "@/shared/http";
import { getDashboardReportTypes } from "../../../../services/dashboard-services";

export default function setup(selectedItems = []) {
  const getLoading = inject("getLoading");
  const getItems = inject("getItems");
  const close = inject("close");

  const localStorageName = ref("dashboard-parvandeh-codes");
  const getMergedItems = () => {
    const storageData = localStorage.getItem(localStorageName.value);
    const storageItems = JSON.parse(storageData) || [];
    const mergedItems = [...storageItems, ...selectedItems];
    const uniqueItems = setUniqueArrayOfObjects(mergedItems, "code");
    return uniqueItems;
  };
  const setItemsToStorage = () => {
    const mergedItems = getMergedItems();
    localStorage.setItem(localStorageName.value, JSON.stringify(mergedItems));
  };

  const loading = ref(false);
  const generateParvandehQueryString = (extraQueryStrings = null) => {
    const items = getMergedItems();
    if (!items.length) return "";

    const codesArray = items.map((row) => row.code);
    const queryString = generateQueryStringWithKeysRepeat(
      codesArray,
      "parvandeh_code",
      extraQueryStrings
    );
    return queryString;
  };

  const getData = async (data = null, closeable = true) => {
    const items = getMergedItems();
    if (!items.length) return;
    setItemsToStorage();

    const algorithmName = pathOr(null, ["algorithmName"], data);
    const tabKey = pathOr("tab1", ["key"], data);
    switch (tabKey) {
      case "tab1":
        getTab1Data(closeable);
        break;
      case "tab2":
        getTab2Data(closeable);
        break;
      case "tab3":
        getTab3Data(closeable, algorithmName);
        break;
      case "tab4":
        getTab3Data(closeable, algorithmName);
        break;
      case "tab5":
        getTab3Data(closeable, algorithmName);
        break;
      case "tab6":
        getTab3Data(closeable, algorithmName);
        break;
      case "tab7":
        getTab3Data(closeable, algorithmName);
        break;
    }
  };
  const getTab1Data = async (closeable) => {
    try {
      loading.value = true;
      const queryString = generateParvandehQueryString();
      const url = generateApiUrl(["report", "summary_parvandeh"]) + queryString;
      const response = await httpService.get(url);
      const data = pathOr([], ["data", "data"], response);
      getItems(data);
      if (closeable) {
        close();
      }
      getDashboardReportTypes(queryString);
    } catch (error) {
      generateError(error);
    } finally {
      loading.value = false;
    }
  };
  const getTab2Data = async (closeable) => {
    try {
      loading.value = true;
      const queryString = generateParvandehQueryString();
      const url =
        generateApiUrl(["report", "competency_washup_scores"]) + queryString;
        
      const response = await httpService.get(url);
      const data = pathOr([], ["data", "data"], response);
      getItems(data);
      if (closeable) {
        close();
      }
    } catch (error) {
      generateError(error);
    } finally {
      loading.value = false;
    }
  };
  const getTab3Data = async (closeable, algorithmName) => {
    try {
      loading.value = true;
      const extraQueryStrings = { algorithm_name: algorithmName };
      const queryString = generateParvandehQueryString(extraQueryStrings);
      const url = generateApiUrl(["report", "dashboard_report"]) + queryString;

      const response = await httpService.get(url);
      const data = pathOr([], ["data", "data"], response);
      getItems(data);
      if (closeable) {
        close();
      }
    } catch (error) {
      generateError(error);
    } finally {
      loading.value = false;
    }
  };

  // tracked loading and sent to parent layers
  watch(loading, (value) => getLoading(value));

  return { loading, getData };
}
